import React, { useEffect, useState } from "react";
import moment from "moment";

import {
	Button,
	Form,
	Modal, OverlayTrigger, Tooltip
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import FormService from "../../../../core/service/FormService";
import { FORMTYPES, FormType } from "../../../../core/constants/common";
import MatAssessmentService from "../../../../core/service/MatAssessmentService";


function AssessmentReminderModal({ t, id, onHide, lastSubmissionDate, formType = FormType.GENERAL }) {

	const [assessment, setAssessment] = useState(null);

	const [days, setDays] = useState(1);
	const [daysOffset, setDaysOffset] = useState(1);
	const [reminderEnabled, setReminderEnabled] = useState(false);

	useEffect(() => {
		if (!id) return;

		getAssessment();
	}, [id]);

	const getAssessment = () => {
		FormService.getAssessment(id).then(res => {
			if (res.status !== 200) return;

			setAssessment(res.data);
			if (res.data.remindBefore == 0) {
				setDays(res.data.remindBefore + 1);
			} else {
				setDays(res.data.remindBefore)
			}
			setDaysOffset(res.data.daysOffset ?? 1);
			setReminderEnabled(res.data.reminderEnabled ?? false);
		}).catch(err => { });
	};


	const onSave = () => {
		if (!assessment || days == 0) return;

		assessment.remindBefore = +days;
		assessment.daysOffset = +daysOffset;
		assessment.reminderEnabled = reminderEnabled;
		let req;
		if (formType === FormType.SURVEY) {
			req = MatAssessmentService.updateAssessment(id, assessment);
		} else {
			req = FormService.updateAssessment(id, assessment);
		}	
		req.then(res => {
			if (res.status !== 200) return;

			toast.success(t('ReminderConfigured.label'), {
				position: toast.POSITION.TOP_RIGHT,
			});
			onHide(true);
		}).catch(err => { })
	};

	const getFormattedDate = () => {
		const lastDate = new Date(lastSubmissionDate);
		let totaldays = null;
		totaldays = days === null ? 1 : days;
		const tenDaysBefore = new Date(lastDate);
		tenDaysBefore.setDate(lastDate.getDate() - totaldays);	
		return tenDaysBefore.toISOString().split('T')[0];
	};

	return (
		<>
			<Modal show={true} onHide={() => onHide(false)}
				aria-labelledby="contained-modal-title-vcenter"
				centered>
				<Modal.Header className="border-0">
					<Modal.Title as="h5">
						{t('SetReminder.label')}
					</Modal.Title>

					<button
						onClick={() => onHide(false)}
						className="ms-2 btn-close"
						aria-label="Close"
					>
					</button>

				</Modal.Header>
				<Modal.Body>
					<div className="row m-0 Send_reminderBox p-2">
						<div className="d-flex  align-items-center pb-4">

							<Form.Check
								className=" ms-3"
								type="switch"
								key={`reminderEnabledToggle`}
								id={`reminderEnabledToggle`}
								variant="outline-primary"
								checked={reminderEnabled}
								onChange={() => setReminderEnabled(!reminderEnabled)}

							/>
							{!reminderEnabled && <span>Turn on automatic reminder</span>}
							{reminderEnabled && <span>Automatic reminder is on</span>}


						</div>
						<div className="col-md-3 col-4 p-0 text-right">
							Send once in
						</div>
						<div className="col-md-2 col-3 p-0">
							<input
								type="number"
								className="form-control ms-2 me-2"
								value={daysOffset}
								min="1" max="20"
								disabled={!reminderEnabled}
								onChange={(e) => setDaysOffset(+e.target.value)}
								onBlur={(e) => {
									if (!e.target.value || +e.target.value < 1) {
										setDaysOffset(1);
									}
								}}
							/>
						</div>
						<div className="col-md-7 col-5 p-0 ">
							day {daysOffset > 1 && <span>(s) </span>} 
						</div>
					</div>
					<div className="row m-0 Send_reminderBox p-2">
						<div className="col-md-3 col-4 p-0 text-right">
							Start sending
						</div>
						<div className="col-md-2 col-3 p-0">
							<input
								type="number"
								className="form-control ms-2 me-2"
								value={days}
								min="1" max="20"
								disabled={!reminderEnabled}
								onChange={(e) => setDays(e.target.value)} />
						</div>
						<div className="col-md-7 col-5 p-0 ">
							day {days > 1 && <span>(s) </span>} before expiry date ({moment(lastSubmissionDate).format("MMMM DD, YYYY")})
						</div>
					</div>
					{reminderEnabled &&
						<div className="px-2 text-center pt-3 fst-italic">
							Occurs every {daysOffset} days from  {moment(getFormattedDate()).format("MMMM DD, YYYY")}
						</div>
					}

				</Modal.Body>
				<Modal.Footer>
					<Button variant="primary" className="px-3" onClick={() => onSave()}>{t('Save.label')}</Button>
				</Modal.Footer>

			</Modal >
		</>
	);
}

export default withTranslation()(AssessmentReminderModal);